import axios from "axios";

import appSettings from "../../../../config/config";
const apiUrl = appSettings.apiUrl

const subscribeViaResellerRecharge = async (resellerId, businessDetails, notes) => {
  try {
    await axios.post(
      `${apiUrl}/api/v1/partner/portal/reseller/${resellerId}/business/${businessDetails.id}/subscribeViaRecharge`,
      {
        pricingSegmentId: businessDetails.pricingSegmentId,
        eventData: {
          "businessId": businessDetails.id,
          "notes": notes,
        }
      }
      );
    } catch (e) {
      console.error(e);
      throw new Error(e.response.data || "server error");
    }
};

const createFreeTrialExtension = async (resellerId, businessId, numberOfDays, notes) => {
  try {
    await axios.post(
      `${apiUrl}/api/v1/partner/portal/reseller/${resellerId}/business/${businessId}/extendFreeTrial`,
      {
        freeTrialDays: numberOfDays,
        eventData: {
          "businessId": businessId,
          "notes": notes,
        }
      }
    );
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getResellerBusinesses = async ({ resellerId, bId, options }) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/reseller/${resellerId}/businesses/`,
      {
        params: {
          bId,
          options
        }
      }
    );
    return response.data.businesses || [];
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getResellerBusinessesByEmail = async (email, resellerId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/reseller/${resellerId}/getBusinessesByEmail?email=${email}`
    );
    return response.data.businesses || [];
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

const getResellerBusinessesCount = async (resellerId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/partner/portal/reseller/${resellerId}/businesses/count`
    );
    return response.data || 0;
  } catch (e) {
    console.error(e);
    throw new Error(e.response.data || "server error");
  }
};

export default {
  subscribeViaResellerRecharge,
  createFreeTrialExtension,
  getResellerBusinesses,
  getResellerBusinessesByEmail,
  getResellerBusinessesCount
};
